import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DealProduct from './deal-product';
import DealProductDetail from './deal-product-detail';
import DealProductUpdate from './deal-product-update';
import DealProductDeleteDialog from './deal-product-delete-dialog';

const DealProductRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DealProduct />} />
    <Route path="new" element={<DealProductUpdate />} />
    <Route path=":id">
      <Route index element={<DealProductDetail />} />
      <Route path="edit" element={<DealProductUpdate />} />
      <Route path="delete" element={<DealProductDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DealProductRoutes;
